export enum AddContactMethod{
    quickSend = 'quick',
    bulkAdd = 'bulk'
}